<template>
    <div class="switch3">
         <div class="changeBox">
              <div class="mianBox clearfix" :class="{small:size=='small'}">
                <div :class="{active: checked == 1 }" @click='change(1)' class="leftBox" >
                    <p>{{title1}}</p>
                </div>
                <div :class="{active: checked == 2 }" class="rightBox" @click="change(2)">
                    <p>{{title2}}</p>
                </div>
                <div :class="{active: checked == 3 }" class="right2" @click="change(3)">
                    <p>{{title3}}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        title1:{
            default: ""
        },
        title2:{
            default: ""
        },
        title3:{
            default: ""
        },
        size:{
            default: ""
        },
    },
    data() {
        return {
             checked: 1,
        }
    },
    mounted() {

    },
    methods: {
        change(v){
            this.checked=v;
            this.$emit('change',this.checked);
        }
    }
}
</script>
<style lang='less'>
.switch3 {
    .changeBox{
       .mianBox{
           margin: 0 auto;
           width: 150px;
           height:35px;
            position: relative;
           .leftBox, .rightBox,.right2 {
                background-color: #d1d1d1;
                height:35px;
                width:100px;
                left:0;
                position: absolute;
                text-align: center;
                line-height: 35px;
                float: left;
                color:#fff;
                border-radius:0.896rem;
           }
           .rightBox{
               left:75px;
                background-color: #ccc;
           }
           .right2{
            left:100px;
            z-index: 1;
             background-color: #ddd;
           }
           .active{
                background-color: #F69C2D;

                font-weight: bold;
                 z-index: 2;
           }
       }
        .small{
            width:100px;
             .leftBox, .rightBox,.right2 {
                 width: 75px;
             }
            .rightBox{
                left:53px;
            }
            .right2{
            left:105px;
           }
        }
    }
}
</style>



// WEBPACK FOOTER //
// switch3.vue?7bfbd6f2